
import { sha256 } from 'js-sha256';
import moment from 'moment';

import logger from '../app/logger';
import { apiKEY } from '../config/constants';
import getRoomName from '../config/getRoomName';
import { fetchAxiosApi } from '../mtApi/functions';
import { isDomainWeborNative } from '../util/checkOS';

declare var config: Object;


/**
 * Selector for retrieving the disabled sounds array.
 *
 * @param {Object} state - The Redux state.
 * @returns {Array<string>} - The disabled sound id's array.
 */
export function getDisabledSounds(state: Object) {
    const { confSettings } = state['features/base/jwt'];

    if (typeof confSettings?.disabledSounds !== 'undefined') {
        // Return immediately if confSettings exists
        const jwtDisabledSounds
            = confSettings?.disabledSounds ?? state['features/base/config']?.disabledSounds ?? [];

        return Promise.resolve(Array.isArray(jwtDisabledSounds) ? jwtDisabledSounds : []);
    }

    // Handle async operation with getModeratorOptions
    return getModeratorOptions(state).then(moderatorOptions => {
        const optionsDisabledSounds = Array.isArray(moderatorOptions?.disabledSounds)
            ? moderatorOptions.disabledSounds
            : undefined;

        const disabledSounds
            = state['features/base/config']?.disabledSounds
            ?? optionsDisabledSounds
            ?? [];

        return Array.isArray(disabledSounds) ? disabledSounds : [];
    })
    .catch(error => {
        logger.error('Error fetching disabled sounds:', error);

        return [];
    });
}


/**
 * Selector for retrieving the disabled sounds array.
 *
 * @param {Object} state - The Redux state.
 * @returns {Object<any>} - Returns MeetingSetting Object
 */
export async function getModeratorOptions(state: Object) {

    const { API_URL_PREFIX, API_VERSION_PREFIX, MH_CLIENT_ID } = state['features/base/config'] ?? config;
    const locationURL = state['features/base/connection']?.locationURL;
    const roomName = state['features/base/conference']?.room
        ?? (locationURL ? getRoomName(locationURL.href) : undefined);

    if (!roomName || !API_URL_PREFIX || !API_VERSION_PREFIX || !MH_CLIENT_ID) {
        return {};
    }

    if (API_URL_PREFIX && API_VERSION_PREFIX && MH_CLIENT_ID) {
        try {

            const moements = moment().seconds(0)
            .milliseconds(0)
            .format('X');

            const mesh256z = sha256(`${apiKEY}:MH:${moements}`);

            const response = await fetchAxiosApi('meeting/moderatoroptions', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: {
                    client_id: MH_CLIENT_ID,
                    credentials: mesh256z,
                    ...isDomainWeborNative,
                    meeting_id: roomName
                },
                config: {
                    API_URL_PREFIX,
                    API_VERSION_PREFIX
                }
            }).then(settingData => {

                if (typeof settingData !== 'undefined' && settingData?.settings) {
                    const { settings } = settingData;

                    return settings;
                }

                return {};

            });

            return response;

        } catch (e) {
            logger.error('catch', e);

            return {};
        }
    } else {
        return {};
    }
}

/**
 * getsoundsPath in our project
 *
 */
export function getSoundsPath() {
    return 'sounds';
}
